import React from 'react';
import PropTypes from 'prop-types';
import RaaDefaultButton from '../RaaDefaultButton/RaaDefaultButton';

function GenericErrorFallback({ resetErrorBoundary }) {
  return (
    <div className="text-center py-5">
      <h1 className="text-danger" aria-label="page error">
        <i className="fa fa-warning" />
        Oops!
      </h1>
      <p>
        Something went wrong.
        <br />
      </p>
      <RaaDefaultButton
        type="button"
        onClick={resetErrorBoundary}
        ariaLabel="reload page"
      >
        Reload Page
      </RaaDefaultButton>
    </div>
  );
}

GenericErrorFallback.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
  }).isRequired,
  resetErrorBoundary: PropTypes.func.isRequired,
};

export default GenericErrorFallback;
